import { useMemo } from "react";

import * as Converter from "./converter";
import * as DiscountItemOrdinaryShared from "../../../../_shared";
import { useNewDiscountLongTermStayFormModel } from "../../model";
import { useCreateDiscountLongTerm } from "../use-create-discount-long-term";

export const useInitialized = (hotelID: string, duplicateDiscountID?: string) => {
	const { discountLongTermNewItemForLongStayTermServerModel } =
		DiscountItemOrdinaryShared.Model.Repository.Query.useDiscountLongTermNewItemForLongStayTermQuery(
			hotelID,
			duplicateDiscountID,
		);

	const initInputModel: DiscountItemOrdinaryShared.Model.ModelType.DiscountLongTermStayFormModel["InputModel"] =
		useMemo(
			() =>
				Converter.serverModelToInputModelConverter(hotelID, discountLongTermNewItemForLongStayTermServerModel),
			[discountLongTermNewItemForLongStayTermServerModel, hotelID],
		);

	const { inputModel, viewModel, onSetViewModel } = useNewDiscountLongTermStayFormModel(initInputModel);

	const {
		//
		// 公開にする
		onPublish,
		// 非公開にする
		onUnpublish,

		// 基本設定
		// ディスカウント名の変更
		onChangeName,
		// ディスカウント説明の変更
		onChangeDescription,
		// ディスカウントコードの変更
		onChangeDiscountCode,
		// 連泊ディスカウントの追加
		onAddLongTermStayDiscountObject,
		// 連泊ディスカウントの割引方法の変更
		onChangeDiscountType,
		// 連泊ディスカウントの泊数の変更
		onChangeIncludeSmallestNights,
		// 連泊ディスカウントのの固定割引の対象の変更
		onChangeStaticTargetType,
		// 連泊ディスカウントの割引の割合額の変更
		onChangeRatio,
		// 連泊ディスカウントの割引の固定額の変更
		onChangeStatic,
		// 連泊ディスカウントの削除
		onDeleteLongTermStayDiscountObject,

		// 追加設定
		// 最低価格の変更
		onChangeResourceLowestPrice,
		// ディスカウント上限金額を設定しない
		onUnSettingDiscountPriceTotalLimit,
		// ディスカウント上限金額の変更
		onChangeDiscountPriceTotalLimit,
		// ディスカウントをプラン限定にするかの変更
		onChangeSaleTypeForPlan,
		// キャンセル不可のディスカウントにするかの変更
		onChangeIsUncancelable,
		// ディスカウントの利用可能期間を設定するかの変更
		onChangeSaleTypeForTerm,
		// 公開期間を変更
		onChangeSale,
		// 利用可能期間を変更
		onChangeStayable,
		// 利用可能曜日の変更
		onChangeStayableDayOfTheWeek,
		// 部屋の適用条件の変更
		onChangeRoomConditionType,
	} = DiscountItemOrdinaryShared.Model.UseCase.useActions(viewModel, onSetViewModel);
	const { onCreateDiscountLongTerm } = useCreateDiscountLongTerm(inputModel);

	return {
		//
		viewModel,
		// mutation
		onCreateDiscountLongTerm,

		//
		// 公開にする
		onPublish,
		// 非公開にする
		onUnpublish,

		// 基本設定
		// ディスカウント名の変更
		onChangeName,
		// ディスカウント説明の変更
		onChangeDescription,
		// ディスカウントコードの変更
		onChangeDiscountCode,
		// 連泊ディスカウントの追加
		onAddLongTermStayDiscountObject,
		// 連泊ディスカウントの割引方法の変更
		onChangeDiscountType,
		// 連泊ディスカウントの泊数の変更
		onChangeIncludeSmallestNights,
		// 連泊ディスカウントのの固定割引の対象の変更
		onChangeStaticTargetType,
		// 連泊ディスカウントの割引の割合額の変更
		onChangeRatio,
		// 連泊ディスカウントの割引の固定額の変更
		onChangeStatic,
		// 連泊ディスカウントの削除
		onDeleteLongTermStayDiscountObject,

		// 追加設定
		// 最低価格の変更
		onChangeResourceLowestPrice,
		// ディスカウント上限金額を設定しない
		onUnSettingDiscountPriceTotalLimit,
		// ディスカウント上限金額の変更
		onChangeDiscountPriceTotalLimit,
		// ディスカウントをプラン限定にするかの変更
		onChangeSaleTypeForPlan,
		// キャンセル不可のディスカウントにするかの変更
		onChangeIsUncancelable,
		// ディスカウントの利用可能期間を設定するかの変更
		onChangeSaleTypeForTerm,
		// 公開期間を変更
		onChangeSale,
		// 利用可能期間を変更
		onChangeStayable,
		// 利用可能曜日の変更
		onChangeStayableDayOfTheWeek,
		// 部屋の適用条件の変更
		onChangeRoomConditionType,
	};
};
